import '@coddicat/vue-pinch-scroll-zoom/style.css'

import PinchScrollZoom from '@coddicat/vue-pinch-scroll-zoom'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default ({ app }) => {
  app.component('PinchScrollZoom', PinchScrollZoom)
}
